import appendQuery from 'append-query';

import { RECEIVE_ROUTE_DETAILS, REQUEST_ROUTE_DETAILS } from 'constants/reduxActions';
import { SEARCH_COLOR_SWATCHES_COOKIE } from 'constants/cookies';
import { HYDRA_SEARCH_COLOR_SWATCHES } from 'constants/hydraTests';
import { termSearch } from 'apis/diamond';
import { pageTypeChange } from 'actions/common';
import {
  landingPageAuthRedirect,
  processReceivedTaxonomyBrandPageResponse,
  receiveLandingPageResponse,
  requestLandingPageInfo
} from 'actions/landing/landingPageInfo';
import { processReceivedSearchResponse } from 'actions/fancyUrls';
import { requestSearch } from 'actions/products';
import { redirectTo } from 'actions/redirect';
import { getAssignmentGroup } from 'actions/ab';
import { termToSeoPath } from 'helpers/SeoUtils';
import { fetchErrorMiddleware } from 'middleware/fetchErrorMiddleware';
import { err, setError } from 'actions/errors';

export const requestRouteDetails = term => ({
  type: REQUEST_ROUTE_DETAILS,
  term
});

export const receiveRouteDetails = (term, routeDetails) => ({
  type: RECEIVE_ROUTE_DETAILS,
  term,
  routeDetails
});

export function wildCardSearch({ term }, { termSearch: search } = { termSearch }) {
  return (dispatch, getState) => {
    const appState = getState();
    const { client: { request }, environmentConfig: { api: { diamond } } } = appState;
    dispatch(requestRouteDetails(term));

    return search(diamond, { term }, request, appState)
      .then(fetchErrorMiddleware)
      .then(response => {

        const { proxy_response: proxyResponse, route_details: routeDetails } = response;
        const { type, location } = routeDetails;

        dispatch(receiveRouteDetails(term, routeDetails));

        switch (type) {
          case 'brand': // this won't get called until typed search is implemented
            const { brand_id: brandId } = routeDetails;
            dispatch(pageTypeChange('brand'));
            return processReceivedTaxonomyBrandPageResponse(proxyResponse, brandId, dispatch, getState);
          case 'landing':
            const { page_name: pageName } = routeDetails;
            const { pageType, customerAuth } = proxyResponse;
            dispatch(requestLandingPageInfo(pageName));
            if (pageType === 'AuthenticationFull' && customerAuth !== 'FULL') {
              return dispatch(landingPageAuthRedirect(pageName));
            } else {
              dispatch(pageTypeChange('landing'));
              return dispatch(receiveLandingPageResponse(proxyResponse, pageName));
            }
          case 'search':
            let url = termToSeoPath(term);

            // SEO tweak for `crss` test. Adding `plsr=1` QS param when in test.
            const hydraSearchColorSwatches = Boolean(getAssignmentGroup(HYDRA_SEARCH_COLOR_SWATCHES, appState)) && appState.cookies[SEARCH_COLOR_SWATCHES_COOKIE] !== 'off';
            if (hydraSearchColorSwatches && !url.includes('plsr=1')) {
              url = appendQuery(url, 'plsr=1');
            }

            dispatch(pageTypeChange('search'));
            dispatch(requestSearch({ url, isFresh: true }));
            return processReceivedSearchResponse(proxyResponse, dispatch, getState, {}, url);
          case 'redirect':
            return dispatch(redirectTo(location));
          case 'external_redirect':
            return dispatch(redirectTo(location));
          default:
            return null;
        }
      })
      .catch(e => dispatch(setError(err.GENERIC, e, 404)));
  };
}
